
import DefaultDialog from "@/components/dialogs/Default";
import UploadDialogs from "@/components/dialogs/PhotoUpload";
import FormRules from "@/utils/formRules.js";
import FileUpload from "@/mixins/fileupload";
import CreatorMixin from "@/mixins/creatorData.js"
import { updateCreator } from "@/firebase/api/creator";


export default {
    components: { DefaultDialog, UploadDialogs },
    mixins: [FormRules, FileUpload, CreatorMixin],
    props: {
        value: { type: Boolean, required: true },
        currentCreators: { type: Array, required: true },
    },

    data: () => ({
        valid: true,
        creatorID: null,
        snackbar: false,
        submitting: false,
        name: "",
    }),
    computed: {
        fileinputID() {
            return 'creatorFileInput';
        },
        previewImageID() {
            return 'creatorPreviewImage';
        },
        nameErrorMessage() {
            const filter = creator => creator.name === this.name;
            const creatorsWithSameName = this.currentCreators.filter(filter);
            const thisIsANewCreator = creatorsWithSameName.length === 0;
            const nameErrorMessage = this.evaluateCreatorExistence(thisIsANewCreator)
            return nameErrorMessage;
        },
        enabled: {
          get() {
            return this.value;
          },
          set(v) {
            this.$emit("input", v);
          }
        },
        filepath() {
            return "creators/" + this.creatorID;
        }
    },
	methods: {
        uploadFinished(url) {
            this.beforeUpdateCreator && this.beforeUpdateCreator();
            updateCreator(this.creatorID, { photo: url }, this.type);
            this.closeForm();
        },
      
        submit() {
            this.validate();
            if (this.valid) {
              this.submitting = true;
              this.updateDatabase()
            }
        },
        validate() {
            this.$refs.form.validate();
        },
        reset() {
            this.$refs.form.reset();
        },
        closeForm() {
            this.reset();
            this.enabled = false;
        },
	}
}